
export const keyEnterSubmitForm = (submit) => ({ key }) => {
    if (key === 'Enter') {
        submit()
    }
}
